import React, {useEffect} from 'react';
import * as actions from '../actions';

export function FieldAppInspectionDashboard() {

	return <div className='dashboard inspection'>

		<div className='searchForm'>
			<button className='icon iconLabel iconRight searchParameter'><span>All</span></button>
			<input type='search' placeholder='Search' autoCapitalize='none' autoCorrect='off' value='' />
			<button className='icon search disabled'><span>&nbsp;</span></button>
		</div>

		<section className='expander collapsed'>
			<header><button tabIndex={1}><span className='icon tenPercent'>TEN PERCENT <span className='subtitle'></span></span></button>
				<div className='icon iconExpander'><span></span><span></span></div>
				<div className='actions'></div>
			</header>
			<div>
				<div className='inner clearfix'>
					All the stuff goes here
				</div>
			</div>
		</section>

		<section className='expander expanded'>
			<header><button tabIndex={1}><span className='icon inspect'>INSPECT <span className='subtitle'></span></span></button>
				<div className='icon iconExpander'><span></span><span></span></div>
				<div className='actions'></div>
			</header>
			<div className=''>
				<table className='interactive' cellPadding='0' cellSpacing='0'>
					<tbody> 
						<tr>
							<td></td>
							<td className='action'><button className='icon iconOnly pinned'><span></span></button></td>
							<td className='date'><strong>10/31/2022</strong></td>
							<td className='relayNumberAccountingId'>102915.00</td>
							<td className='address'>624 S. Sagewood Dr</td>
							<td className='name'>Darryl Philbin</td>
							<td className='action navigate'></td>
							<td></td>
						</tr>
						<tr>
							<td></td>
							<td className='action'><button className='icon iconOnly pin'><span></span></button></td>
							<td className='date'><strong>11/02/2022</strong></td>
							<td className='relayNumberAccountingId'>110312.00</td>
							<td className='address'>252 W. Sunbeam Way</td>
							<td className='name'>Darryl Philbin</td>
							<td className='action navigate'></td>
							<td></td>
						</tr>
					</tbody>
				</table>
			</div>
		</section>

		<section className='expander collapsed'>
			<header><button tabIndex={1}><span className='icon install'>INSTALL <span className='subtitle'></span></span></button>
				<div className='icon iconExpander'><span></span><span></span></div>
				<div className='actions'></div>
			</header>
			<div>
				<div className='inner clearfix'>
					All the stuff goes here
				</div>
			</div>
		</section>

		<section className='expander collapsed'>
			<header><button tabIndex={1}><span className='icon deliver'>DELIVER <span className='subtitle'></span></span></button>
				<div className='icon iconExpander'><span></span><span></span></div>
				<div className='actions'></div>
			</header>
			<div>
				<div className='inner clearfix'>
					All the stuff goes here
				</div>
			</div>
		</section>

		<section className='expander collapsed'>
			<header><button tabIndex={1}><span className='icon service'>SERVICE <span className='subtitle'></span></span></button>
				<div className='icon iconExpander'><span></span><span></span></div>
				<div className='actions'></div>
			</header>
			<div>
				<div className='inner clearfix'>
					All the stuff goes here
				</div>
			</div>
		</section>

		<section className='expander collapsed'>
			<header><button tabIndex={1}><span className='icon pinned'>PINNED <span className='subtitle'></span></span></button>
				<div className='icon iconExpander'><span></span><span></span></div>
				<div className='actions'></div>
			</header>
			<div>
				<div className='inner clearfix'>
					All the stuff goes here
				</div>
			</div>
		</section>
	</div>;
}